// Utility per determinare l'unità di misura corretta per i prodotti

export const getProductUnit = (product) => {
  const { brand = '', category = '', name = '' } = product;
  
  const brandLower = brand.toLowerCase();
  const categoryLower = category.toLowerCase();
  const nameLower = name.toLowerCase();
  
  // Icobit - Gestione specifica per prodotto
  if (brandLower === 'icobit') {
    // Icojoint MS e BT → Flaconi
    if (nameLower.includes('icojoint')) {
      return 'flaconi';
    }
    // ICORAM BAND e ICORAM TNT → Rotoli
    if (nameLower.includes('icoram band') || nameLower.includes('icoram tnt') || nameLower.includes('icoramband')) {
      return 'rotoli';
    }
    // BUTYL TAPE → Rotoli
    if (nameLower.includes('butyl tape')) {
      return 'rotoli';
    }
    // EXIT AIR → Singola/Scatola
    if (nameLower.includes('exit air')) {
      return 'scatola';
    }
    // GEO-DRAIN 100 → Singola/Scatola
    if (nameLower.includes('geo-drain')) {
      return 'scatola';
    }
    // Default per altri prodotti Icobit → Flaconi
    return 'flaconi';
  }
  
  // Herbol, AREA 51, Sikkens → Latta
  if (brandLower === 'herbol' || brandLower === 'area 51' || brandLower === 'sikkens') {
    return 'latte';
  }
  
  // Sistemi per Cartongesso → Pannello
  if (categoryLower.includes('cartongesso')) {
    return 'pannelli';
  }
  
  // ALTRO e Sistemi di fissaggio → Pezzi
  if (categoryLower === 'altro' || categoryLower.includes('fissaggio')) {
    return 'pezzi';
  }
  
  // Default per tutti gli altri
  return 'sacchi';
};

export const getPalletQuantity = (product) => {
  const { brand = '' } = product;
  const brandLower = brand.toLowerCase();
  
  // Herbol, AREA 51, Sikkens → 33 latte per bancale
  if (brandLower === 'herbol' || brandLower === 'area 51' || brandLower === 'sikkens') {
    return 33;
  }
  
  // Default 54
  return 54;
};

export const canUseBancale = (product) => {
  const { category = '', brand = '', name = '' } = product;
  const categoryLower = category?.toLowerCase() || '';
  const brandLower = brand?.toLowerCase() || '';
  const nameLower = name?.toLowerCase() || '';
  
  // Icobit prodotti che NON usano bancali
  if (brandLower === 'icobit') {
    // Icojoint, ICORAM BAND, ICORAM TNT, BUTYL TAPE, EXIT AIR, GEO-DRAIN → NO bancali
    if (nameLower.includes('icojoint') || 
        nameLower.includes('icoram') || 
        nameLower.includes('butyl tape') ||
        nameLower.includes('exit air') ||
        nameLower.includes('geo-drain')) {
      return false;
    }
  }
  
  // Categorie che NON usano bancali
  const noBancaleCategories = [
    'sistemi di posa piastrelle',
    'altro',
    'sistemi di fissaggio'
  ];
  
  return !noBancaleCategories.some(cat => categoryLower.includes(cat));
};

